import { render, staticRenderFns } from "./PaymentMethodForm.vue?vue&type=template&id=67c7f4d2&scoped=true&"
import script from "./PaymentMethodForm.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodForm.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodForm.vue?vue&type=style&index=0&id=67c7f4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7f4d2",
  null
  
)

export default component.exports